import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ApiResponse} from "../../base/repository/entity/base.entity";
import {LoginRequest, LoginResponse} from "./entity/auth.entity";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AuthRepository {

  constructor(
    private http: HttpClient
  ) {
  }

  login(payload: LoginRequest): Observable<ApiResponse<LoginResponse>> {
    return this.http.post<ApiResponse<LoginResponse>>(`${environment.baseUrl}/user/login`, payload);
  }

  refresh(): Observable<ApiResponse<LoginResponse>> {
    return this.http.get<ApiResponse<LoginResponse>>(`${environment.baseUrl}/user/refresh-token`);
  }

}
